import PropTypes from 'prop-types';
import React from 'react';
import Choice from '../_internal/Choice';

const Radio = ({
  id,
  name,
  isChecked,
  isReadOnly,
  onChange,
  isDisabled,
  tabIndex,
  value,
  variant,
}) => {
  return (
    <Choice
      onChange={onChange}
      isChecked={isChecked}
      isDisabled={isDisabled}
      value={value}
      variant={variant}
      id={id}
      isReadOnly={isReadOnly}
      name={name}
      type="radio"
      tabIndex={tabIndex}
    />
  );
};

Radio.propTypes = {
  /**
   * The input id.
   */
  id: PropTypes.string,
  /**
   * Set the checked attribute on the checkbox input.
   */
  isChecked: PropTypes.bool,
  /**
   * Disables the checkbox control.
   */
  isDisabled: PropTypes.bool,
  /**
   * Set the checkbox control as read only.
   */
  isReadOnly: PropTypes.bool,
  /**
   * The input name.
   */
  name: PropTypes.string,
  /**
   * Sets the onChange handler on checkbox input.
   */
  onChange: PropTypes.func,
  /**
   * Tab index.
   */
  tabIndex: PropTypes.number,
  /**
   * Sets the value on checkbox input.
   */
  value: PropTypes.any,
  /**
   * Sets the theme variant.
   */
  variant: PropTypes.string,
};

Radio.defaultProps = {
  id: undefined,
  isChecked: undefined,
  isDisabled: undefined,
  isReadOnly: undefined,
  name: undefined,
  onChange: undefined,
  tabIndex: 0,
  value: undefined,
  variant: 'medium',
};

export default Radio;
